import { IGetArquivoUseCase } from "../../../presentation/useCases/read/get_arquivo_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

export class GetArquivoUseCase implements IGetArquivoUseCase {
  constructor(private readonly repository: IQualidadeRepository) { }

  async getArquivo(
    IdAcaoQualidade: number,
    imagePosition: number,
    imageName: string,
  ): Promise<void> {
    const blob = await this.repository.getArquivo(
      IdAcaoQualidade,
      imagePosition,
    );

    if (!blob) throw new Error("Falha ao buscar dados da imagem!");

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", String(imageName));
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
